import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public
export const submitInquiry = (payload) => axios.post(`${API}/inquiries`, payload);
export const requestChecklist = (payload) => axios.post(`${API}/checklist/request`, payload);
export const checklistDownloadUrl = `${API}/checklist/download`;

// Admin
const TOKEN_KEY = "bcc_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminLogin = (email, password) =>
  axios.post(`${API}/admin/login`, { email, password });

export const adminMe = () =>
  axios.get(`${API}/admin/me`, { headers: authHeader() });

export const adminInquiries = () =>
  axios.get(`${API}/admin/inquiries`, { headers: authHeader() });

export const adminUpdateStatus = (id, status) =>
  axios.patch(
    `${API}/admin/inquiries/${id}/status`,
    { status },
    { headers: authHeader() }
  );

export const adminStats = () =>
  axios.get(`${API}/admin/stats`, { headers: authHeader() });
